
import React from 'react';
import { User } from '../types.ts';
import { Bell, User as UserIcon } from 'lucide-react';

interface NavbarProps {
  user: User;
}

const Navbar: React.FC<NavbarProps> = ({ user }) => {
  const [imageError, setImageError] = React.useState(false);

  // Reset image error when user or avatar changes
  React.useEffect(() => {
    setImageError(false);
  }, [user.id, user.avatar_url]);

  return (
    <header className="h-16 bg-[#1e2329] border-b border-[#474d57] px-6 flex items-center justify-end z-10">
      <div className="flex items-center gap-4">
        <button className="p-2 text-white hover:text-[#00ff66] transition-colors relative">
          <Bell size={20} />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-[#00ff66] rounded-full border-2 border-[#1e2329]"></span>
        </button>

        <div className="h-8 w-[1px] bg-[#474d57] mx-2"></div>

        <div className="flex items-center gap-3 cursor-pointer group">
          <div className="text-right hidden sm:block">
            <p className="text-sm font-semibold text-white">{user.name}</p>
            <p className="text-xs text-white opacity-80 uppercase font-black tracking-widest">{user.role}</p>
          </div>
          <div className="w-10 h-10 rounded-full bg-[#2b3139] border border-[#474d57] overflow-hidden flex items-center justify-center text-[#00ff66] group-hover:border-[#00ff66] transition-all">
            {user.avatar_url && !imageError ? (
              <img
                src={user.avatar_url}
                alt={user.name}
                className="w-full h-full object-cover"
                onError={() => setImageError(true)}
              />
            ) : (
              <UserIcon size={20} />
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
